import PropTypes from 'prop-types';
import cn from '../../../../../utils/cn';
import { isEmpty } from 'lodash';
import Divider from '../../../Divider/Divider';
import ContactInformation from '../../../Contact/ContactInformation/ContactInformation';
import DraftEditorField from '../../../../Form/DraftEditorField/DraftEditorField';
import ServiceTypes from '../../../ServiceTypes/ServiceTypes';
import { FormattedMessage } from 'react-intl';

const ProgramDescription = (props) => {
  const {
    className = '',
    program: {
      description,
      email_addresses,
      phone_numbers,
      service_types,
      website_url,
    },
    showMore = false,
  } = props;

  const showContactInfo =
    !isEmpty(email_addresses) ||
    !isEmpty(phone_numbers) ||
    !isEmpty(website_url);

  return (
    <div className={className} >
      {
        !isEmpty(service_types) && (
          <ServiceTypes serviceTypes={service_types} />
        )
      }
      {
        showMore && (
          <div className={cn({ hidden: !description })}>
            {!isEmpty(service_types) ?
              (<Divider className="-mx-5" />) : null}
            {
              showContactInfo &&
                <ContactInformation
                  className="my-5"
                  email_addresses={email_addresses}
                  headerText={<FormattedMessage
                    id="hBX91R"
                    description="contact-information"
                    defaultMessage="Program Contact Information"
                  />}
                  phone_numbers={phone_numbers}
                  showMore={showMore}
                  website_url={website_url}
                />
            }

            <h4 className="mb-2 text-sm text-text-blue font-medium font-heavy-font">
              <FormattedMessage
                id="rT7jXR"
                description="description-label"
                defaultMessage="Description"
              />
            </h4>
            <DraftEditorField
              className="mb-8"
              hideLabel
              id="program-description-text"
              label={<FormattedMessage
                id="rT7jXR"
                description="description-label"
                defaultMessage="Description"
              />}
              readOnly
              value={description}
            />
          </div>
        )
      }
    </div>
  );
};

ProgramDescription.propTypes = {
  className: PropTypes.string,
  program: PropTypes.shape({
    description: PropTypes.string,
    email_addresses: PropTypes.array,
    phone_numbers: PropTypes.array,
    service_types: PropTypes.array,
    website_url: PropTypes.string,
  }).isRequired,
  showMore: PropTypes.bool,
};

export default ProgramDescription;
